import { useEffect } from 'react'

export const MEDAL_PORTFOLIO_IMAGE_LEAVE_MESSAGE = '선택한 메달 포트폴리오 이미지는 저장 전에 이동하면 사라집니다. 이동하시겠습니까?'

export const hasPendingMedalPortfolioImage = (image) => {
    return image instanceof File
}

// 다이얼로그 내부 file input 값은 복구할 수 없어서, 새로고침/탭 닫기 직전에만 기본 경고를 띄운다.
export const usePendingMedalPortfolioImageUnloadGuard = (enabled) => {
    useEffect(() => {
        if (typeof window === 'undefined' || !enabled) {
            return undefined
        }

        const handleBeforeUnload = (event) => {
            event.preventDefault()
            event.returnValue = ''
            return ''
        }

        window.addEventListener('beforeunload', handleBeforeUnload)

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload)
        }
    }, [enabled])
}
